import { useParams } from 'react-router-dom';
import { getSongIdFromUrlSongParams, isAIGeneratedSong } from './helpers';

const useSongId = () => {
  const { songParams } = useParams<{ songParams: string }>();

  try {
    // @ts-ignore
    const isAIGenerated = isAIGeneratedSong(songParams);
    // @ts-ignore
    const id = getSongIdFromUrlSongParams(songParams);
    return {
      isAIGenerated,
      id,
    };
  } catch (error) {
    return {
      error: error as Error,
    };
  }
};

export default useSongId;
